import './App.css';
import Page from './Page';

// This is the main component that renders the page
// The page component contains everything on the page
function App() {
  return (
    <Page />
  ) 
}

export default App;
